import { render, staticRenderFns } from "./blackout.vue?vue&type=template&id=37e6bc31&scoped=true&"
import script from "./blackout.vue?vue&type=script&lang=js&"
export * from "./blackout.vue?vue&type=script&lang=js&"
import style0 from "./blackout.vue?vue&type=style&index=0&id=37e6bc31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e6bc31",
  null
  
)

export default component.exports